import React from "react"
import autobind from "class-autobind"
import { Drawer, CircularProgress } from "material-ui"
import { IWorkflow } from "../../models"
import AppStateStore from "../../stores/AppStateStore"
import strings from "../../localization/strings"
import WorkflowStepCard from "./WorkflowStepCard"
import WorkflowDescription from "./WorkflowDescription"
import WorkflowProgress from "./WorkflowProgress"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as api from "../../api"

interface IProps {
    handleClose(): void,
    workflowId: string,
}
interface IState {
    openDrawer: boolean
    loading: boolean
    workflow: IWorkflow
}

export default class WorkflowDrawer extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            openDrawer: false,
            loading: true,
            workflow: null,
        }
        autobind(this)
    }

    componentDidMount() {
        this.loadWorkflowData()
    }

    loadWorkflowData() {
        api.getUserWorkflow(AuthenticationStore.getCookieUserId(), this.props.workflowId).then(res =>
            this.setState({ loading: false, workflow: res.data.Workflow })
        )
    }

    handleClose() {
        this.setState({ openDrawer: false }, () =>
            setTimeout(() =>
                this.props.handleClose(), 100
            )
        )
    }

    render() {
        const contentWidth = AppStateStore.getContentWidth()
        return (
            <Drawer
                open
                openSecondary
                width={contentWidth >= 1200 ? 1200 : contentWidth}
                docked={false}
                overlayStyle={{ zIndex: 1500 }}
                containerStyle={{ zIndex: 1500, opacity: open ? 1 : 0, transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}
                onRequestChange={this.props.handleClose}
            >
                <div>
                    <div style={{ padding: 35, backgroundColor: AppStateStore.getDrawerHeaderColor(), textAlign: "center", color: "#ffffff", fontWeight: "normal", fontSize: 25 }}>
                        {strings.Workflow}
                        <i className="fa fa-close itemActionButton" style={{ float: "right" }} onClick={this.props.handleClose} />
                    </div>
                    {this.state.loading &&
                        <div style={{ padding: 50, textAlign: "center" }}>
                            <CircularProgress />
                        </div>
                    }
                    {this.state.workflow &&
                        <div>
                            <div style={{ padding: 50, marginBottom: 20, backgroundColor: "#002c59", color: "white" }}>
                                <WorkflowDescription workflow={this.state.workflow} showTitles={true} />
                                <div style={{ marginTop: 20 }}>
                                    <WorkflowProgress workflow={this.state.workflow} />
                                </div>
                            </div>
                            <div style={{ paddingTop: 20, paddingLeft: 50, paddingRight: 50, paddingBottom: 50 }}>
                                {this.state.workflow.Steps.map((item, index) =>
                                    <div style={{ marginBottom: 20 }} key={index} ><WorkflowStepCard step={item} key={index} onReload={this.loadWorkflowData} /></div>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </Drawer>
        )
    }
}